import React, { Fragment } from 'react';
import ChargeTesla from '../ChargeTesla';

const ChargePolicy = () => (
  <Fragment>
    <p>
      It is your responsibility to return the vehicle with at least 70%
      battery charge, to avoid any charging fees. This policy ensures the
      car has a sufficient battery level for the next driver.
      <ul>
        <li>
          A <strong>fee of $1.39 ($2.00/kWh) for every 1%</strong> under the 70%
          threshold upon vehicle drop-off.
        </li>
        <li>
          A <strong>credit of $1.21 for every 1%</strong> under the 70%
          threshold upon vehicle pick-up.
        </li>
      </ul>
    </p>
    <p>For example:</p>
    <table className="faq__table">
      <thead>
        <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
          Battery % at pickup
        </th>
        <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
          Battery % at dropoff
        </th>
        <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
          Credit = $1.21 per 1%
        </th>
        <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
          Fee = $1.39 per - 1%
        </th>
        <th className="faq__table__th" style={{ fontWeight: 'bold' }}>
          Total fee/credit at end of booking
        </th>
      </thead>
      <tbody>
        <tr>
          <td className="faq__table__right">85%</td>
          <td className="faq__table__right">75%</td>
          <td className="faq__table__right">
            $0.00, car started above 70%
          </td>
          <td className="faq__table__right">$0.00, car ended above 70%</td>
          <td className="faq__table__right">$0.00</td>
        </tr>
        <tr>
          <td className="faq__table__right">70%</td>
          <td className="faq__table__right">35%</td>
          <td className="faq__table__right">$0.00, car started on 70%</td>
          <td className="faq__table__right">35% x $1.39 = $48.65</td>
          <td className="faq__table__right" style={{ color: '#ff0000' }}>
            -$48.65 fee
          </td>
        </tr>
        <tr>
          <td className="faq__table__right">25%</td>
          <td className="faq__table__right">85%</td>
          <td className="faq__table__right">%45 x $1.21 = $54.45</td>
          <td className="faq__table__right">$0.00, car ended above 70%</td>
          <td className="faq__table__right" style={{ color: '#3dc700' }}>
            +$54.45 credit
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <p>
      You will be automatically offered credit at the start of your booking
      if the battery level is lower than 70%
    </p>
    <p>
      To charge the vehicle, head to the nearest{' '}
      <a
        href="https://www.google.com/maps/@/data=!3m1!4b1!4m3!11m2!2suPulXnH1Tsy1bV7WYoayRA!3e3?shorturl=1"
        className="faq__panel--link"
        target="_blank">
        Tesla Supercharger
      </a>{' '}
      or any third-party charging station. Autzu does not cover any cost
      associated with Supercharging and you will be invoiced for any
      charging fees incurred during your booking session.
    </p>
    {/* <br />
    <h4 className="subtitle">How do I charge the Tesla?</h4>
    <ChargeTesla /> */}
  </Fragment>
);

export default ChargePolicy;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/ChargePolicy.js